export default process.env.RAZZLE_DEBUG_MODE === 'true'
